// 楼宇管理
const Building = () => import('@/views/building/index.vue')

export default {
  Building
}
